import React, { useState } from 'react';
import { Box, Typography, Button, TextField } from '@mui/material';
import { motion } from 'framer-motion';

interface WelcomeProps {
  onStart: (name: string) => void;
}

const Welcome: React.FC<WelcomeProps> = ({ onStart }) => {
  const [catName, setCatName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (catName.trim()) onStart(catName.trim());
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 4, pb: 6, gap: 3 }}>

        {/* Logo */}
        <img
          src="/maologo.jpg"
          alt="小胖毛"
          style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', boxShadow: '0 8px 28px rgba(45,27,16,0.15)' }}
        />

        {/* 標題 */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h4" sx={{ color: '#2D1B10', lineHeight: 1.2, mb: 1 }}>
            貓咪 MBTI 性格測驗
          </Typography>
          <Typography sx={{ fontSize: 15, color: '#6B4C3B', lineHeight: 1.6 }}>
            20 道問題，找出你的貓咪是哪種性格
          </Typography>
        </Box>

        {/* 說明卡片 */}
        <Box
          sx={{
            width: '100%', maxWidth: 560,
            background: '#fff',
            borderRadius: 4,
            border: '1.5px solid #E8E4E0',
            boxShadow: '0 4px 24px rgba(107,76,59,0.08)',
            p: { xs: 3, sm: 4 },
            display: 'flex', flexDirection: 'column', gap: 3,
          }}
        >
          {/* 四個維度 */}
          <Box>
            <Typography variant="h6" sx={{ color: '#2D1B10', mb: 1.5, fontSize: '1rem !important' }}>
              測驗說明
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
              {[
                { a: '內向 I', b: '外向 E' },
                { a: '感覺 S', b: '直覺 N' },
                { a: '思考 T', b: '感受 F' },
                { a: '判斷 J', b: '知覺 P' },
              ].map((dim, i) => (
                <Box
                  key={i}
                  sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                    background: 'rgba(245,166,35,0.06)',
                    border: '1px solid rgba(245,166,35,0.2)',
                    borderRadius: 2, px: 2, py: 1,
                    fontSize: 13, color: '#6B4C3B', fontWeight: 600,
                  }}
                >
                  <span>{dim.a}</span>
                  <span style={{ color: '#9CA3AF' }}>vs</span>
                  <span>{dim.b}</span>
                </Box>
              ))}
            </Box>
            <Typography sx={{ fontSize: 13, color: '#9CA3AF', mt: 1.5, lineHeight: 1.6 }}>
              共 20 題，約 5 分鐘完成。根據直覺選擇最符合貓咪個性的選項。
            </Typography>
          </Box>

          {/* 輸入貓咪名字 */}
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="貓咪的名字"
              value={catName}
              onChange={(e) => setCatName(e.target.value)}
              required
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  '& fieldset': { borderColor: '#E8E4E0' },
                  '&:hover fieldset': { borderColor: '#6B9FD4' },
                  '&.Mui-focused fieldset': { borderColor: '#6B9FD4' },
                },
                '& .MuiInputLabel-root.Mui-focused': { color: '#6B4C3B' },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={!catName.trim()}
              sx={{
                py: 1.5, borderRadius: 2,
                fontSize: '1rem', fontWeight: 700,
                background: '#2D1B10',
                fontFamily: '"Nunito", sans-serif',
                '&:hover': { background: '#4A2D1A' },
                '&:disabled': { background: '#E8E4E0', color: '#9CA3AF' },
              }}
            >
              開始測驗 →
            </Button>
          </Box>
        </Box>

        {/* 底部 watermark */}
        <Typography sx={{ fontSize: 12, color: '#9CA3AF' }}>
          🐱 由 Smallfatmao 小胖毛 出品
        </Typography>

      </Box>
    </motion.div>
  );
};

export default Welcome;
